/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbContactSummary } from './HchbContactSummary';
import {
    HchbContactSummaryFromJSON,
    HchbContactSummaryFromJSONTyped,
    HchbContactSummaryToJSON,
    HchbContactSummaryToJSONTyped,
} from './HchbContactSummary';

/**
 * 
 * @export
 * @interface HchbPhysicianSummary
 */
export interface HchbPhysicianSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    npi?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    contacts?: Array<HchbContactSummary>;
}

/**
 * Check if a given object implements the HchbPhysicianSummary interface.
 */
export function instanceOfHchbPhysicianSummary(value: object): value is HchbPhysicianSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function HchbPhysicianSummaryFromJSON(json: any): HchbPhysicianSummary {
    return HchbPhysicianSummaryFromJSONTyped(json, false);
}

export function HchbPhysicianSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPhysicianSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'npi': json['npi'] == null ? undefined : json['npi'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(HchbContactSummaryFromJSON)),
    };
}

export function HchbPhysicianSummaryToJSON(json: any): HchbPhysicianSummary {
    return HchbPhysicianSummaryToJSONTyped(json, false);
}

export function HchbPhysicianSummaryToJSONTyped(value?: HchbPhysicianSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'npi': value['npi'],
        'city': value['city'],
        'state': value['state'],
        'phone': value['phone'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(HchbContactSummaryToJSON)),
    };
}

